module.exports = __webpack_public_path__ + "img/yo-logo-web.5eab5215.png";